import api from "@/api/index";

export default {
  balance(credentials) {
    return api().get("user/balances", credentials);
  },
  transactions(credentials) {
    return api().get("user/transactions", credentials);
  },
  logs(credentials) {
    return api().get("user/logs", credentials);
  },
  refers(credentials) {
    return api().get("user/refers", credentials);
  },
  update(credentials) {
    return api().post("user/update", credentials);
  },
  wallet(credentials) {
    return api().get("deposit/wallet", credentials);
  },
  twofactor(credentials) {
    return api().get("security/twofa", credentials);
  },
  enable2fa(credentials) {
    return api().post("security/enable2fa", credentials);
  },
  disable2fa(credentials) {
    return api().post("security/disable2fa", credentials);
  },
  mailconfirm(credentials) {
    return api().post("security/mailconfirm", credentials);
  },
  transfer(credentials) {
    return api().post("transfer", credentials);
  },
  withdraw(credentials) {
    return api().post("withdraw", credentials);
  },
  withdrawhistory(credentials) {
    return api().get("withdraw/history", credentials);
  },
  cancelwithdraw(credentials) {
    return api().post("withdraw/cancel", credentials);
  },
  deposithistory(credentials) {
    return api().get("deposit/history", credentials);
  },
};
